import styled from 'styled-components'

export const TopButtonsContainer = styled.div`
  position: relative;
  display: flex;
  justify-content: flex-end;
  width: 100%;

  > * {
    position: absolute;
    bottom: 0;
    right: 0;

    @media (max-width: 900px) {
      position: static;
    }
  }
`
